const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaqIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17,37.14V21.07h6.86v2.17H19.31v4.87h4v2.17h-4v6.86Z",
    style: {
      fill: "#30373d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.19,37.14l3.59-16.07H28.7l3.58,16.07H30l-.68-3.45H26.17l-.68,3.45Zm5.69-5.62L27.75,25.7H27.7l-1.12,5.82Z",
    style: {
      fill: "#30373d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.28,24.86a4.21,4.21,0,0,1,.33-1.71,3.66,3.66,0,0,1,2.14-2,3.91,3.91,0,0,1,1.38-.25,4,4,0,0,1,1.39.25,3.81,3.81,0,0,1,1.25.72,3.66,3.66,0,0,1,.88,1.24A4,4,0,0,1,41,24.86v8.49A3.64,3.64,0,0,1,40.65,35l1.42,1.15-1.17,1.4-1.35-1.1a3.8,3.8,0,0,1-2.42.83A3.91,3.91,0,0,1,35.75,37a3.52,3.52,0,0,1-1.23-.74,3.44,3.44,0,0,1-.91-1.2,4.14,4.14,0,0,1-.33-1.73Zm2.3,8.49A1.54,1.54,0,0,0,36,34.58a1.64,1.64,0,0,0,1.09.39,1.15,1.15,0,0,0,.5-.09l-1-.83,1.17-1.4.93.74V24.86a1.54,1.54,0,0,0-.46-1.23,1.66,1.66,0,0,0-1.1-.39,1.64,1.64,0,0,0-1.09.39,1.54,1.54,0,0,0-.46,1.23Z",
    style: {
      fill: "#30373d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.91,45.34H14.09a5.78,5.78,0,0,1-5.77-5.77V18.43a5.78,5.78,0,0,1,5.77-5.77H43.91a5.78,5.78,0,0,1,5.77,5.77V39.57A5.78,5.78,0,0,1,43.91,45.34ZM14.09,14.66a3.77,3.77,0,0,0-3.77,3.77V39.57a3.77,3.77,0,0,0,3.77,3.77H43.91a3.77,3.77,0,0,0,3.77-3.77V18.43a3.77,3.77,0,0,0-3.77-3.77Z",
    style: {
      fill: "#30373d"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIcon);
export default __webpack_public_path__ + "static/media/FAQ_icon.29d15fa8f6b2b1b561ae447311461d33.svg";
export { ForwardRef as ReactComponent };